// Old routes and where they live now (INFORMATION_ARCHITECTURE.md section 3),
// so bookmarks keep working. Params carry over by name.
export const WORKSPACE_REDIRECTS = [
  ["/fronter/dashboard", "/dashboard"],
  ["/closer/dashboard", "/dashboard"],
  ["/manager/dashboard", "/floor"],
  ["/admin/dashboard", "/dashboard"],
  ["/communications", "/calls"],
  ["/coach/team", "/team"],
  ["/coach/agents/:userId", "/team/:userId"],
  ["/coach/calls/:callId", "/calls/:callId"],
];
